import { render } from "./MinhaAssinatura.vue?vue&type=template&id=147c6e58"
import script from "./MinhaAssinatura.vue?vue&type=script&lang=js"
export * from "./MinhaAssinatura.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__